{
  "info": "Informaţii",
  "negative": "Eroare",
  "positive": "Succes"
}
